import type { AddressVerificationStore } from "services/addressVerification/addressVerificationStore";
import type { AnalyticsManager } from "services/analytics/analyticsManager";
import { type IssuesStore } from "services/issues/issuesStore";
import { IdentityQuestion } from "services/questions/au/identityConstants";
import { QuestionsStore } from "services/questions/questionsStore";
import { type SumsubApplicationStore } from "services/sumsub/sumsubApplicationStore";

export class IdentityQuestionsStore extends QuestionsStore<IdentityQuestion> {
  constructor(
    private readonly _addressVerificationStore: AddressVerificationStore,
    private readonly _sumsubStore: SumsubApplicationStore,
    private readonly _analyticsManager: AnalyticsManager,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(IdentityQuestion, _issuesStore);
  }

  protected _shouldSkipQuestion(question: IdentityQuestion): boolean {
    switch (question) {
      case IdentityQuestion.Poa:
        return !this._addressVerificationStore.isPoaRequired;
      case IdentityQuestion.DriversDetails:
        return this._sumsubStore.hasAllDocsDetails;
    }

    return super._shouldSkipQuestion(question);
  }

  protected _getPreviousQuestionKey(): IdentityQuestion | undefined {
    const prevQuestionKey = super._getPreviousQuestionKey();

    switch (prevQuestionKey) {
      case IdentityQuestion.IdentityCompliance:
        return IdentityQuestion.Identity;
    }

    return prevQuestionKey;
  }

  protected _getRelevantQuestion(): IdentityQuestion {
    this._analyticsManager.event(`sumsub-check-condition`, {
      isPassedVerifications: this._sumsubStore.isPassedVerifications,
      hasAllDocsDetails: this._sumsubStore.hasAllDocsDetails,
      isPoaRequired: this._addressVerificationStore.isPoaRequired,
    });

    if (!this._sumsubStore.isPassedVerifications) {
      return IdentityQuestion.Identity;
    }

    if (!this._sumsubStore.hasAllDocsDetails) {
      return IdentityQuestion.DriversDetails;
    }

    return IdentityQuestion.IdentityCompliance;
  }
}
